'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var ButtonPlain = require('../../01.atoms/ButtonPlain/ButtonPlain.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-teaser-login',
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnContent = "".concat(CLASSNAME, "__content"),
    cnList = "".concat(CLASSNAME, "__list"),
    cnItem = "".concat(CLASSNAME, "__item"),
    cnButtons = "".concat(CLASSNAME, "__buttons"),
    cnButton = "".concat(CLASSNAME, "__button");
/**
 * 
 */

var TeaserLogin = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(TeaserLogin, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(TeaserLogin);

  function TeaserLogin() {
    _rollupPluginBabelHelpers.classCallCheck(this, TeaserLogin);

    return _super.apply(this, arguments);
  }

  _rollupPluginBabelHelpers.createClass(TeaserLogin, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          headline = _this$props.headline,
          content = _this$props.content,
          items = _this$props.items,
          linkRegister = _this$props.linkRegister,
          linkLogin = _this$props.linkLogin,
          labelLogin = _this$props.labelLogin,
          labelRegister = _this$props.labelRegister,
          onClickLogin = _this$props.onClickLogin,
          onClickRegister = _this$props.onClickRegister;
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(className, CLASSNAME)
      }, /*#__PURE__*/React__default.createElement("h3", {
        className: cnTitle
      }, headline), /*#__PURE__*/React__default.createElement("p", {
        className: cnContent,
        dangerouslySetInnerHTML: {
          __html: content
        }
      }), /*#__PURE__*/React__default.createElement("ul", {
        className: cnList
      }, items.map(function (item, index) {
        return /*#__PURE__*/React__default.createElement("li", {
          className: cnItem,
          key: index
        }, /*#__PURE__*/React__default.createElement(Icon, {
          className: cnIcon,
          id: "check",
          size: "xs"
        }), item);
      })), /*#__PURE__*/React__default.createElement("div", {
        className: cnButtons
      }, /*#__PURE__*/React__default.createElement(ButtonPlain, {
        className: cnButton,
        link: linkRegister,
        onClick: onClickRegister,
        title: labelRegister,
        type: "light"
      }), /*#__PURE__*/React__default.createElement(ButtonPlain, {
        className: cnButton,
        link: linkLogin,
        onClick: onClickLogin,
        title: labelLogin,
        type: "light"
      })));
    }
  }]);

  return TeaserLogin;
}(React__default.Component);
TeaserLogin.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Title string */
  headline: PropTypes.string.isRequired,

  /** Array of items for list */
  items: PropTypes.array.isRequired,

  /** Content string */
  content: PropTypes.string,

  /** Text for login button */
  labelLogin: PropTypes.string,

  /** Text for register button */
  labelRegister: PropTypes.string,

  /** URL to register */
  linkRegister: PropTypes.string,

  /** URL for login */
  linkLogin: PropTypes.string,

  /** Callback function */
  onClickLogin: PropTypes.func,

  /** Callback function */
  onClickRegister: PropTypes.func
};
TeaserLogin.defaultProps = {
  items: [],
  onClickLogin: function onClickLogin() {
    return void 0;
  },
  onClickRegister: function onClickRegister() {
    return void 0;
  }
};

module.exports = TeaserLogin;
